export const validationEmail = (email) => {
	const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if (!pattern.test(email)) {
		return false;
	} else {
		return true;
	}
};

export const validationPassword = (password) => {
	const pattern = /^.*(?=^.{8,20}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/;
	if (!pattern.test(password)) {
		return false;
	} else {
		return true;
	}
};

export const validationPhoneNumber = (phoneNumber) => {
	const pattern = /^01([0|1|6|7|8|9]?)?([0-9]{3,4})?([0-9]{4})$/;
	if (!pattern.test(phoneNumber)) {
		return false;
	} else {
		return true;
	}
};

export const validationBotId = (id) => {
	const pattern = /^[a-zA-Z0-9]*$/;
	if (!pattern.test(id)) {
		return false;
	} else {
		return true;
	}
};

export const validationName = (id) => {
	const pattern = /^[가-힣a-zA-Z]+$/;
	if (!pattern.test(id)) {
		return false;
	} else {
		return true;
	}
};

export const numWithComma = (value) => {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
